import httpService from '@/services/httpService';
import ApiEndpoints from '@/utils/ApiEndpoints';

export default {
    postNote (familyEditionId, data) {
        return httpService.post(ApiEndpoints.get('further_story', { familyEditionId }), data);
    },
    putNote (familyEditionId, noteId, data) {
        return httpService.put(ApiEndpoints.get('further_story', { familyEditionId, noteId }), data);
    },
    deleteNote (familyEditionId, noteId) {
        return httpService.delete(ApiEndpoints.get('further_story', { familyEditionId, noteId }));
    },
    postSummary (familyEditionId, data) {
        return httpService.post(ApiEndpoints.get('further_story_summary', { familyEditionId }), data);
    }
};
